/* eslint-disable react/button-has-type */
// eslint-disable-next-line react/button-has-type

import React from 'react';
import * as _ from 'lodash';
import { Form, Input, Table } from 'semantic-ui-react';

const GlobalAttributeComponent = (props) => {
  const [globalList, setglobaList] = React.useState(
    _.keyBy(_.get(props, 'attributeObj.globalList', []), 'attributeName')
  );

  const { attributeObj, formik } = props;

  // check if the attribute is custom created attribute or from the global attribute
  // const checkforCustomAttribute = (dict , attribute) =>{
  //   const id = _.get(dict, `${attribute}.id`, '')
  //   if(dict[attribute] && id ){
  //      return false
  //   }
  //   return true
  // }

  const valueChange = (event) => {
    const tempObj = _.cloneDeep(globalList);
    const { name } = event.target;
    tempObj[name].value = event.target.value;
    const initialValue = _.get(formik, 'values.global_attributes', {});
    initialValue[event.target.name] = event.target.value;
    formik.setFieldValue('global_attributes', initialValue);
    // if (!_.isEmpty(event.target.value)) {
    //   initialValue[event.target.name] = event.target.value;
    //   formik.setFieldValue('global_attributes', initialValue);
    // } else if (_.isEmpty(event.target.value)) {
    //   if(checkforCustomAttribute(tempObj, name)){
    //     initialValue[event.target.name] = event.target.value;
    //     // const removedKeyValue = _.omit(initialValue, event.target.name);
    //     formik.setFieldValue('global_attributes', initialValue);
    //   }
    //   else{
    //     initialValue[event.target.name] = event.target.value;
    //     const removedKeyValue = _.omit(initialValue, event.target.name);
    //     formik.setFieldValue('global_attributes', removedKeyValue);
    //   }

    // }
    setglobaList(tempObj);
  };
  // set initial value of custom attribute and global attribute
  React.useEffect(() => {
    const formValues = _.get(formik, 'values.global_attributes', {});

    if (!_.isEmpty(formValues)) {
      setglobaList((prevState) => {
        const tempGlobalAttributeDict = _.keyBy(prevState, 'attributeName');
        const tempState = _.cloneDeep(tempGlobalAttributeDict);
        Object.keys(formValues).forEach((e) => {
          if (!_.isEmpty(_.get(tempGlobalAttributeDict[e], 'attributeName', ''))) {
            tempState[e].value = formValues[e];
          } else {
            const tempObj = {
              value: formValues[e],
              attributeName: e,
              attributeDisplayName: e,
              attributeType: 'string',
            };
            tempState[e] = tempObj;
          }
        });

        return tempState;
      });
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', width: '60%' }}>
      <Table id="partsTable">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2}>{attributeObj.displayAttributeName || attributeObj.name}</Table.HeaderCell>
            <Table.HeaderCell width={1}>Value</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        {globalList &&
          !_.isEmpty(globalList) &&
          Object.keys(globalList).map((e) => (
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <Form.Field>
                    <div>{globalList[e].attributeDisplayName}</div>
                  </Form.Field>
                </Table.Cell>
                <Table.Cell>
                  <Form.Field>
                    <Input
                      type={globalList[e].attributeType === 'string' ? 'Text' : 'Number'}
                      value={globalList[e].value}
                      name={globalList[e].attributeName}
                      onChange={(event) => {
                        valueChange(event);
                      }}
                    />
                  </Form.Field>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          ))}
      </Table>
    </div>
  );
};

export default GlobalAttributeComponent;
